export default "__VITE_ASSET__BGqtfyuk__"